export const getAnalyticsLocalStorage = (companyId = '') => {
  const ajsEntries = {}
  const prefix = companyId ? `${companyId}_` : 'ajs_'

  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      if (key.indexOf(prefix) === 0) {
        ajsEntries[key] = localStorage[key]
      }
    }
  }

  return ajsEntries
}

export const prefixAjsLocalStorage = (companyId) => {
  const entries = getAnalyticsLocalStorage()

  for (const key in entries) {
    if (entries.hasOwnProperty(key)) {
      localStorage.setItem(`${companyId}_${key}`, entries[key])
    }
  }
}

export const setAjsLocalStorageByCompanyId = (companyId) => {
  const existingLocalStorage = getAnalyticsLocalStorage(companyId)

  for (const key in existingLocalStorage) {
    if (existingLocalStorage.hasOwnProperty(key)) {
      const keyWithoutCompanyId = key.replace(`${companyId}_`, '')
      localStorage.setItem(keyWithoutCompanyId, existingLocalStorage[key])
    }
  }
}

export const eraseAjsLocalStorage = () => {
  const entries = getAnalyticsLocalStorage()

  for (const key in entries) {
    if (entries.hasOwnProperty(key)) {
      localStorage.removeItem(key)
    }
  }
}
